import { Select } from "antd";
import { useRef, useState } from "react";
import debounce from "lodash/debounce";
import { MyLoader } from "Components/MyLoader/MyLoader";

function DebounceSelect({
  allowClear = false,
  fetchOptions,
  debounceTimeout = 500,
  labelInValue,
  onChange,
  mode,
  value,
  disabled = false,
  size = "",
  ...props
}) {
  const [fetching, setFetching] = useState(false);
  const [options, setOptions] = useState([]);
  const [searchValue, setSearchValue] = useState("");

  const fetchRef = useRef(0);

  const loadOptions = async (value) => {
    const fetchId = ++fetchRef.current;

    setFetching(true);

    const newOptions = await fetchOptions(value);

    if (fetchId !== fetchRef.current) return;

    setOptions(newOptions);
    setFetching(false);
  };

  const debounceFetcher = useRef(
    debounce((value) => {
      loadOptions(value);
    }, debounceTimeout),
  ).current;

  return (
    <Select
      {...props}
      allowClear={allowClear}
      size={size}
      disabled={disabled}
      value={value}
      mode={mode}
      labelInValue={labelInValue}
      showSearch
      filterOption={false}
      searchValue={searchValue}
      onSearch={(value) => {
        setSearchValue(value);
        setOptions([]);
        debounceFetcher(value);
      }}
      onChange={(value) => {
        const safeValues = Array.isArray(value)
          ? value.filter(Boolean)
          : value
            ? [value]
            : [];

        onChange(safeValues);
        setSearchValue("");
      }}
      // onChange={(value, option) => {
      // onChange(option);
      // setSearchValue("");

      // }}
      options={options}
      popupMatchSelectWidth={true}
      classNames={{
        popup: {
          root: "my-select-dropdown",
        },
      }}
      notFoundContent={
        fetching ? (
          <MyLoader size={32} centered margin="0" />
        ) : (
          "Нічого не знайдено"
        )
      }
    />
  );
}
export const SearchSelectDebounce = ({
  placeholder = "Пошук",
  allowClear = false,
  width = "100%",
  customFetch,
  labelInValue = false,
  mode,
  prefix,
  value = [],
  disabled = false,
  onChange = () => {},
  size = "",
}) => {
  return (
    <DebounceSelect
      allowClear={allowClear}
      size={size}
      mode={mode}
      placeholder={placeholder}
      fetchOptions={customFetch}
      style={{ width }}
      labelInValue={labelInValue}
      onChange={onChange}
      prefix={prefix}
      value={value}
      disabled={disabled}
    />
  );
};
